// extracted by mini-css-extract-plugin
export default {"help":"styles_help__ZkO4H","button-wrapper":"styles_button-wrapper__Xwcqj","register-button":"styles_register-button__uz7v-","sbp-logo":"styles_sbp-logo__Xrfl1"};